import React from 'react';
import PropTypes from 'prop-types'
import styled from '@emotion/styled';

const LoadingWrapper = styled('div')`
	${props => props.cover === 'content' ? `
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	` : '' }

	${props => props.cover === 'page' ? `
		position: fixed;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	` : '' }
`

const SVGLoader = styled('div')`
	display: inline-block;
	width: 100px;
	height: 135px;

	svg {
		width: 100%;
		height: 100%;
	}

	@keyframes animate-svg-stroke-1 {
		0% {
			stroke-dashoffset: 657.8500366210938px;
			stroke-dasharray: 657.8500366210938px;
		}
		100% {
			stroke-dashoffset: 0;
			stroke-dasharray: 657.8500366210938px;
		}
	}

	@keyframes animate-svg-fill-1 {
		0% {
			fill: transparent;
		}
		100% {
			fill: rgb(124, 53, 255);
		}
	}

	.svg-elem-1 {
		animation: animate-svg-stroke-1 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s both,
							 animate-svg-fill-1 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s both;
		animation-iteration-count: infinite;
	}

	@keyframes animate-svg-stroke-2 {
		0% {
			stroke-dashoffset: 657.9334106445312px;
			stroke-dasharray: 657.9334106445312px;
		}
		100% {
			stroke-dashoffset: 0;
			stroke-dasharray: 657.9334106445312px;
		}
	}

	@keyframes animate-svg-fill-2 {
		0% {
			fill: transparent;
		}
		100% {
			fill: rgb(124, 53, 255);
		}
	}

	.svg-elem-2 {
		animation: animate-svg-stroke-2 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s both,
							 animate-svg-fill-2 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.9s both;
		animation-iteration-count: infinite;
	}
`

const Loading = (props) => {
	const { align, cover = 'content' } = props
	return (
		<LoadingWrapper className={`${align ? `text-${align}` : ''}`} cover={cover}>
			<SVGLoader>
				<svg width="200" height="270" viewBox="0 0 200 270" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M33.958 33.958C75.9023 -7.98631 143.937 -7.98625 185.882 33.958L191.506 39.583L159.72 71.3691L154.095 65.7451C129.707 41.3577 89.9276 41.3577 65.54 65.7451C41.1525 90.1327 41.1525 129.913 65.54 154.301L71.165 159.926L39.4277 191.662L34.0068 185.932L33.9824 185.906L33.958 185.882L32.9824 184.894C-7.98356 142.876 -7.65851 75.5745 33.958 33.958Z" fill="#7C35FF" stroke="#7C35FF" strokeWidth="5" className="svg-elem-1"></path>
					<path d="M165.141 84.0672C185.428 104.354 196.855 131.037 196.855 159.926C196.855 188.831 185.621 215.715 165.347 235.99C145.074 256.263 117.985 267.5 89.2822 267.5C60.3762 267.5 33.4927 256.265 13.2178 235.99L7.5918 230.364L39.1729 198.783L44.7988 204.409C56.5733 216.183 72.4104 222.597 89.0762 222.597C105.952 222.597 121.583 216.18 133.354 204.409C145.129 192.635 151.542 176.797 151.542 160.132C151.542 143.256 145.126 127.625 133.354 115.853L127.729 110.227L159.515 78.4412L165.141 84.0672Z" fill="#7C35FF" stroke="#7C35FF" strokeWidth="5" className="svg-elem-2"></path>
				</svg>
			</SVGLoader>
		</LoadingWrapper>
	)
}

Loading.propTypes = {
	size: PropTypes.string,
	cover: PropTypes.string
}

Loading.defaultProps = {
	align: 'center',
	cover: 'inline'
};

export default Loading